<template>
  <div class="page">
    <div class="content">
      <div class="head">
        <h2 v-show="!listShow">根据录入的信息，小助手为您推荐以下达人</h2>
        <h2 v-show="listShow && tableData.length !== 0">根据录入的信息，小助手为您推荐以下达人</h2>
        <h2 v-show="listShow && tableData.length === 0">正在为您推荐符合条件的达人...</h2>
        <p>录入的信息更全面，匹配的达人更加符合您的推广需求</p>
      </div>
      <div v-show="!listShow">
        <div class="condition">
          <div class="option_box">
            <h3>您要推广的内容</h3>
            <div class="input_boxs">
              <div class="input_box">
                <span class="box_title">行业<i class="must">*</i></span>
                <el-select v-model="industry" placeholder="请选择">
                  <el-option
                    v-for="item in industrys"
                    :key="item.industryTagId"
                    :label="item.industryTagName"
                    :value="item.industryTagId">
                  </el-option>
                </el-select>
              </div>
              <div class="input_box">
                <span class="box_title">品牌</span>
                <el-input class="el_input" v-model="productName" placeholder="请输入品牌名称，如：华为"></el-input>
              </div>
            </div>
          </div>
          <div class="option_box">
            <span class="box_title">推广目标<i class="must">*</i></span>
            <div class="check_boxs">
              <div class="check_box" v-for="(item, index) of target_options" :key="index"
                :class="item.checked ? 'active': ''" @click="setTarget(item)">
                <div class="check_img">
                  <img :src="item.checked ? item.srcActive : item.imgSrc" alt="">
                </div>
                <div class="check_info">
                  <h4>{{item.name}}</h4>
                  <p>{{item.describe}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="option_box">
            <h3>推广计划</h3>
            <div class="extension">
              <span class="box_title">预算<i class="must">*</i></span>
              <div class="sel_price">
                <div class="price_out" v-for="item of extension_options" :key="item.id">
                  <div class="option_price" :class="item.checked ? 'active' : ''" @click="setPrice(item)">
                    <h4 v-show="!item.toInput">{{item.name}}</h4>
                    <div class="price_input" v-if="item.toInput">
                      <input type="text" v-model="price" @blur="setPriceName(item)" ref="toInput">
                      万元
                    </div>
                    <p :class="textActive ? 'active' : ''">{{item.describe}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="option_box">
            <div class="portrait">
              <div class="portrait_box">
                <span class="box_title">达人数量<i class="must">*</i></span>
                <div class="Gender_box">
                  <div class="age" v-for="(item,index) of darenNum" :key="index" :class="item.checked ? 'active' : ''"
                    @click="setDarenNum(item)">
                    {{item.name}}</div>
                </div>
              </div>
              <div class="portrait_box">
                <span class="box_title">达人类型<i class="must">*</i></span>
                <div class="Gender_box">
                  <div class="age" v-for="(item,index) of darenType" :key="index" :class="item.checked ? 'active' : ''"
                    @click="setDarenType(item)">
                    {{item.name}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="option_box">
            <h3>达人粉丝要求</h3>
            <div class="portrait">
              <div class="portrait_box">
                <span class="box_title">粉丝量<i class="must">*</i></span>
                <div class="Gender_box">
                  <div class="age" v-for="(item,index) of fanNum" :key="index" :class="item.checked ? 'active' : ''"
                    @click="setFanNum(item)" style="width:130px;">
                    {{item.name}}</div>
                </div>
              </div>
              <div class="portrait_box">
                <span class="box_title">性别<i class="must">*</i></span>
                <div class="Gender_box">
                  <div class="age" v-for="(item,index) of Genders" :key="index" :class="item.checked ? 'active' : ''"
                    @click="setGender(item)">
                    {{item.name}}</div>
                </div>
              </div>
              <div class="portrait_box">
                <span class="box_title">年龄<i class="must">*</i></span>
                <div class="Gender_box">
                  <div class="age" v-for="(item,index) of ages" :key="index" :class="item.checked ? 'active' : ''"
                    @click="setAges(item)">
                    {{item.name}}</div>
                </div>
              </div>
              <div class="portrait_box">
                <span class="box_title">地域<i class="must">*</i></span>
                <div class="Gender_box">
                  <div class="age" :class="setArea===0 ? 'active' : ''" @click="setArea = 0">不限</div>
                  <div class="age" :class="setArea===1 ? 'active' : ''" @click="setArea = 1">按省份</div>
                  <div class="age" :class="setArea===2 ? 'active' : ''" @click="setArea = 2">按城市等级</div>
                </div>
                <div class="select_area_province" v-show="setArea === 1">
                  <div class="Gender_box">
                    <div class="Gender" v-for="(item,index) of areasProvince" :key="index" :class="item.checked ? 'active' : ''"
                      @click="setAreaProvince(item)">
                      {{item.name}}</div>
                  </div>
                </div>
                <div class="select_area_city" v-show="setArea === 2">
                  <div class="Gender_box">
                    <div class="Gender" v-for="(item,index) of areasCity" :key="index" :class="item.checked ? 'active' : ''"
                      @click="setAreaCity(item)">
                      {{item.name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="option_box" style="margin-top:0;">
            <div class="portrait" style="margin-top:0;">
              <div class="portrait_box">
                <span class="box_title">内容偏好</span>
                <div class="Gender_box">
                  <div class="age" :class="styleLike===0 ? 'active' : ''" @click="styleLike = 0">不限</div>
                  <div class="age" :class="styleLike===1 ? 'active' : ''" @click="styleLike = 1" v-show="styles.length">其他</div>
                </div>
              </div>
            </div>
            <div class="like_style" v-show="styleLike===1">
              <div class="style_checked" :class="item.checked ? 'active' : ''" v-for="(item,index) of styles"
                :key="index" @click="setStyle(item)">{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="btn_box">
          <div class="btn" @click="matching">匹配达人</div>
        </div>
      </div>
      <div v-show="listShow" class="list">
          <div class="matchingInfo">
            <div class="title">匹配结果</div>
            <div class="rankType">
              <el-select v-model="keyWord" placeholder="默认">
                <el-option
                  v-for="item in keyWords"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="btn" @click="backSet">修改条件</div>
          </div>
        <div class="hasData" v-show="tableData.length !== 0&&!loading">
          <div class="datas">
            <div v-show="!showNoData" class="item" v-for="(item,index) of tableData" :key="index"
              @dblclick="tableBtnClick(item)">
              <img :src="item.headUrl" alt="">
              <div class="info">
                <h2>{{item.name}}</h2>
                <div class="cate">{{item.starTagStr ? item.starTagStr : '-'}}</div>
                <div class="cate" style="margin-left:4px;">{{item.industryTagStr ? item.industryTagStr.split(",")[0] : '-'}}</div>
                <div class="tags">
                  <div class="tag">{{item.provinceCode?item.provinceCode:"-"}}-{{item.cityCode?item.cityCode:"-"}}</div>
                </div>
              </div>
              <div class="num">
                <div v-if="item.fansNumber">
                  {{item.fansNumber > 10000 ? ((item.fansNumber/10000).toFixed(1) + 'w') : item.fansNumber}}
                </div>
                <div v-if="!item.fansNumber">-</div>
                <p>粉丝数</p>
              </div>
              <div class="num">
                <div v-if="item.photoExpectPlay">
                  {{item.photoExpectClick > 10000 ? ((item.photoExpectClick/10000).toFixed(1) + 'w') : item.photoExpectClick}}
                </div>
                <div v-if="!item.photoExpectPlay">-</div>
                <p>预期播放量</p>
              </div>
              <div class="num">
                <div>
                  {{item.photoInteractionRate ? (item.photoInteractionRate*100).toFixed(2)+"%":"-"}}
                </div>
                <p>粉丝互动率</p>
              </div>
              <div class="line"></div>
              <div class="price">
                <span>￥</span>
                <div class="price_text">{{(item.orderBid/1000).toLocaleString()}}</div>
              </div>
              <div class="btn" @click="tableBtnClick(item)">
                详情
              </div>
            </div>
          </div>
        </div>
        <div class="noData" v-show="loading">
          <img src="../../assets/help/nodata.gif" alt="">
          <p>匹配中，请稍等...</p>
        </div>
        <div class="noData" v-show="tableData.length === 0&&!loading">
          <p>暂无数据</p>
        </div>
        <div class="pages">
          <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="20"
            @current-change='pageChange'>
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import brand from '@/assets/help/brand.png'
  import brandActive from '@/assets/help/brand_active.png'
  import online from '@/assets/help/online_retailers.png'
  import onlineActive from '@/assets/help/online_retailers_active.png'
  import down from '@/assets/help/download.png'
  import downActive from '@/assets/help/download_active.png'
  export default {
    data() {
      return {
        industry: '',
        productName: '',
        price: '',
        textActive: false,
        industrys: [],
        listShow: false,
        target_options: [{
            name: '应用下载',
            describe: '提升用户对应用的下载、安装、激活等行为',
            imgSrc: down,
            srcActive: downActive,
            checked: true,
            id: 1
          }, {
            name: '品牌推广',
            describe: '提升用户对品牌活动的了解、参与等行为',
            imgSrc: brand,
            srcActive: brandActive,
            checked: false,
            id: 3
          },
           {
            name: '电商带货',
            describe: '添加小黄车，提升商品总销量',
            imgSrc: online,
            srcActive: onlineActive,
            checked: false,
            id: 2
          }
        ],
        extension_options: [{
          name: '1万元以下',
          describe: '尝鲜体验',
          checked: false,
          id: 0,
          budget: 10000,
          budget_min: 0
        }, {
          name: '1 ~ 5万元',
          describe: '基础预算',
          checked: false,
          id: 1,
          budget: 50000,
          budget_min: 10000
        }, {
          name: '5 ~ 10万元',
          describe: '较多预算',
          checked: false,
          id: 2,
          budget: 100000,
          budget_min: 50000
        }, {
          name: '请输入10万以上预算',
          describe: '自定义预算（10万以上）',
          checked: false,
          id: 3,
          toInput: false,
          budget: 0,
          budget_min: 0
        }],
        darenNum: [{
            name: '1~5',
            value: "5",
            checked: false
          },{
            name: '6~10',
            value: '10',
            checked: false
          },{
            name: '11~15',
            value: '15',
            checked: false
          },{
            name: '16~20',
            value: '20',
            checked: false
          },{
            name: '21~25',
            value: '25',
            checked: false
          }
        ],
        darenType: [{
            name: '视频',
            value: "1",
            checked: false
          },{
            name: '直播',
            value: '4',
            checked: false
          }
        ],
        fanNum: [{
            name: '不限',
            checked: true,
            id: 0,
            maxFansNum:0,
            minFansNum:0
          },
          {
            name: '5万~10万',
            checked: false,
            id: 1,
            maxFansNum:50000,
            minFansNum:100000
          },
          {
            name: '10万~50万',
            checked: false,
            id: 2,
            maxFansNum:500000,
            minFansNum:100000
          },
          {
            name: '50万~100万',
            checked: false,
            id: 3,
            maxFansNum:1000000,
            minFansNum:500000
          },
          {
            name: '100万~500万',
            checked: false,
            id: 4,
            maxFansNum:5000000,
            minFansNum:1000000
          },
          {
            name: '500万~1000万',
            checked: false,
            id: 5,
            maxFansNum:10000000,
            minFansNum:5000000
          },
          {
            name: '1000万以上',
            checked: false,
            id: 6,
            maxFansNum:0,
            minFansNum:10000000
          }
        ],
        Genders: [{
            name: '不限',
            checked: true,
            id: ''
          },
          {
            name: '男性为主',
            checked: false,
            id: 'MALE'
          },
          {
            name: '女性为主',
            checked: false,
            id: 'FEMALE'
          }
        ],
        ages: [{
            name: '不限',
            value: "",
            checked: true
          },
          {
            name: '18岁以下',
            value: '18岁以下',
            checked: false
          },
          {
            name: '18~23',
            value: '18-23',
            checked: false
          },
          {
            name: '24~30',
            value: '24-30',
            checked: false
          },
          {
            name: '31~40',
            value: '31-40',
            checked: false
          },
          {
            name: '41~50',
            value: '41-50',
            checked: false
          },
          {
            name: '50岁以上',
            value: '50+',
            checked: false
          }
        ],
        setArea:0,
        areasProvince: [],
        areasCity: [{
            name: '一线城市',
            value: "first",
            checked: false
          },{
            name: '二线城市',
            value: "second",
            checked: false
          },{
            name: '三线城市',
            value: "third",
            checked: false
          },{
            name: '四线城市',
            value: "fourth",
            checked: false
          },{
            name: '五线城市',
            value: "fifth",
            checked: false
          }
        ],
        styleLike:0,
        styles: [],
        keyWord:"",
        keyWords: [
          {
            value: '',
            label: '默认'
          },{
            value: 1,
            label: '粉丝更多'
          },{
            value: 2,
            label: '播放量更高'
          },{
            value: 3,
            label: '互动性更强'
          }
        ],
        tableData: [],
        showNoData: false,
        loading:true,
        page:{
          currentPage:1,
          total:0
        }
      }
    },
    watch: {
      price(val, oldval) {
        if (val === '') {
          return
        }
        if (!(/^(0|[1-9][0-9]*)$/.test(val))) {
          this.price = oldval
          return;
        }
        if (parseInt(val) >= 10000) {
          this.price = '10000'
          this.extension_options[3].describe = '最大金额不超过1亿元'
          this.textActive = true
        }else if (parseInt(val) < 10) {
          // this.price = '10'
          this.extension_options[3].describe = '最小金额不低于10万元'
          this.textActive = true
        }else {
          this.extension_options[3].describe = '自定义预算(10万以上)'
          this.textActive = false
        }
      },
      industry(val,oldval){
        this.styleLike = 0
        this.$api.ksHelper.getksIndustry('id='+val).then((res) => {
          let styles = []
          if(res.data.data.length>0){
            res.data.data.map(item=>{
              styles.push({
                name: item.starTagName,
                checked: false,
                id: item.starTagId
              })
            })
            this.styles = styles
          }else{
            this.styles =[]
          }
        })
      },
      keyWord(val,oldval){
        let param = this.getParam()
        if(param === "end"||!param){return}
        this.page.currentPage = 1
        if(val){
          param+=`&page=1&rankType=${val}`
        }else{
          param+=`&page=1`
        }
        console.log(param)
        this.listShow = true
        this.getTableData(param)
      }
    },
    computed: {
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        let industrys = JSON.parse(window.localStorage.getItem('getKsIndustrytag') || JSON.stringify({data: {data: []}})).data.data
        this.industrys = industrys
        let address = JSON.parse(window.localStorage.getItem('getKsAddress') || JSON.stringify({data: {data: []}})).data.data
        let areasProvince = []
        address.map(item=>{
          areasProvince.push({
            name: item.provinceName,
            value: item.provinceCode,
            checked: false
          })
        })
        this.areasProvince = areasProvince
      },
      setTarget(val) {
        this.target_options = this.target_options.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setPrice(val) {
        this.extension_options = this.extension_options.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
        this.priceSelect = val.id
        if ('toInput' in val) {
          val.toInput = true
          this.$nextTick(function () {
            this.$refs.toInput[0].focus()
          })
        }
      },
      setPriceName(val) {
        val.toInput = false
        if(this.price<10){
          this.price = 10
        }
        val.name = this.price + '万元'
        this.extension_options[3].describe = '自定义预算(10万以上)'
        this.textActive = false
        this.extension_options[3].budget = parseFloat(this.price) * 10000
      },
      setDarenNum(val){
        this.darenNum = this.darenNum.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setDarenType(val){
        this.darenType = this.darenType.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setFanNum(val) {
        this.fanNum = this.fanNum.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setGender(val) {
        this.Genders = this.Genders.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setAges(val) {
        this.ages = this.ages.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setAreaProvince(val) {
        this.areasProvince = this.areasProvince.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setAreaCity(val) {
        this.areasCity = this.areasCity.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setStyle(val) {
        val.checked = !val.checked
      },
      getParam(){
        let param =''
        let isend =false
        // 行业
        if(this.industry!==''){
          param+=`industryTagId=${this.industry}`
        }else{
          this.$message({
            message: '请选择行业',
            type: 'error'
          });
          return
        }
        // 品牌
        if(this.productName){
          param+=`&brand=${this.productName}`
        }
        // 推广目标
        this.target_options.some(item=>{
          if(item.checked){
            param+=`&promotionType=${item.id}`
            return true
          }
        })
        if(isend){return "end"}
        // 预算
        this.extension_options.some((item,i)=>{
          if(!item.checked&&i===(this.extension_options.length-1)){
            this.$message({
              message: '请选择预算',
              type: 'error'
            });
            isend = true
            return true
          }
          if(item.checked){
            param+=`&maxBudget=${item.budget}&minBudget=${item.budget_min}`
            return true
          }
        })
        if(isend){return "end"}
        // 达人数量
        this.darenNum.some((item,i)=>{
          if(!item.checked&&i===(this.darenNum.length-1)){
            this.$message({
              message: '请选择达人数量',
              type: 'error'
            });
            isend = true
            return true
          }
          if(item.checked){
            param+=`&targetNum=${item.value}`
            return true
          }
        })
        if(isend){return "end"}
        // 达人类型
        this.darenType.some((item,i)=>{
          if(!item.checked&&i===(this.darenType.length-1)){
            this.$message({
              message: '请选择达人类型',
              type: 'error'
            });
            isend = true
            return true
          }
          if(item.checked){
            param+=`&starType=${item.value}`
            return true
          }
        })
        if(isend){return "end"}
        // 粉丝量
        this.fanNum.some((item,i)=>{
          if(item.checked){
            param+=`&maxFansNum=${item.maxFansNum}&minFansNum=${item.minFansNum}`
            return true
          }
        })
        // 性别
        this.Genders.some((item,i)=>{
          if(i===0&&item.checked){
            return true
          }
          if(item.checked){
            param+=`&fansGender=${item.id}`
            return true
          }
        })
        // 年龄
        this.ages.some((item,i)=>{
          if(i===0&&item.checked){
            return true
          }
          if(item.checked){
            param+=`&fansAge=${item.value}`
            return true
          }
        })
        // 地域
        if(this.setArea===1){
          this.areasProvince.some((item,i)=>{
            if(!item.checked&&i===(this.areasProvince.length-1)){
              this.$message({
                message: '请选择省份',
                type: 'error'
              });
              isend = true
              return true
            }
            if(item.checked){
              param+=`&fansProvince=${item.name}`
              return true
            }
          })
        }else if(this.setArea===2){
          this.areasCity.some((item,i)=>{
            if(!item.checked&&i===(this.areasCity.length-1)){
              this.$message({
                message: '请选择城市等级',
                type: 'error'
              });
              isend = true
              return true
            }
            if(item.checked){
              param+=`&fansCity=${item.value}`
              return true
            }
          })
        }
        if(isend){return "end"}
        return param
        
      },
      matching() {
        LA.track('ks_talent_rec');
        let param = this.getParam()
        if(param === "end"||!param){return}
        this.page.currentPage = 1
        param+="&page=1"
        console.log(param)
        this.listShow = true
        this.getTableData(param)
      },
      getTableData(param) {
        this.loading=true
        this.$api.ksHelper.getKsReco(param).then(res => {
          console.log(res)
          if (res.data.code === 0) {
            let tableData = res.data.data.starList
            this.page.total = res.data.data.total
            let address = JSON.parse(window.localStorage.getItem('getKsAddress')).data.data
            tableData!==0&&tableData.map((item,index)=>{
              address.some(v=>{
                if(v.provinceCode===item.provinceCode){
                  v.citys.some(x=>{
                    if(x.cityCode === item.cityCode){
                      tableData[index].cityCode = x.cityName
                      return true
                    }
                  })
                  tableData[index].provinceCode=v.provinceName
                  return true
                }
              })
            })
            this.tableData = tableData
            this.showNoData = false
            this.loading=false
          } else {
            this.$message.error(res.data.error);
            this.loading=false
          }
        })
      },
      tableBtnClick(val) {
        let routeData = this.$router.resolve({
          path: '/ks',
          query: {
            id: val.starId
          }
        })
        window.open(routeData.href, "_blank");
      },
      backSet() {
        this.listShow = false
        this.loading = true
        this.tableData = []
      },
      pageChange(val){
        let param = this.getParam()
        if(param === "end"||!param){return}
        this.page.currentPage=val
        param+=`&page=${val}`
        console.log(param)
        this.listShow = true
        this.getTableData(param)
      }
    }
  }
</script>

<style scoped>
  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    margin: 0;
    padding: 0;
  }

  .content {
    width: 1200px;
    margin: 0 auto;

  }

  .content .head {
    display: flex;
    flex-direction: column;
    background: url(../../assets/help/header_bg.png);
    width: 100%;
    height: 148px;
    border-radius: 6px;
    padding: 45px 40px;
    box-sizing: border-box;
    justify-content: space-between;
  }

  .content .head h2 {
    font-size: 20px;
    font-weight: 500;
    color: #FFFFFF;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .content .head p {
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 0.72;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .content .condition {
    width: 100%;
    margin-top: 20px;
    background: #fff;
    box-sizing: border-box;
    padding: 30px 30px;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    border-bottom: 1px solid #F5F5F6;
  }

  .content .condition h3 {
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: bold;
    color: #333333;
    width: max-content;
  }
  .must{
    display: inline-block;
    margin-left: 3px;
    color: #FF6F28;
    vertical-align:top;
  }

  .content .el_sel>>>.el-input__inner {
    width: 175px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
  }

  .condition .option_box+.option_box {
    margin-top: 30px;
  }


  .input_boxs {
    display: flex;
    margin-top: 20px;
    align-items: center;
  }

  .input_boxs .input_box {
    display: flex;
    flex-direction: column;
  }

  .input_boxs .input_box+.input_box {
    margin-left: 24px;
  }

  .option_box .box_title {
    position: relative;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
    margin-bottom: 12px;
  }

  .input_boxs .input_box .el_input>>>.el-input__inner {
    width: 360px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
  }

  .check_boxs {
    display: flex;
    flex-wrap: wrap;
  }

  .check_boxs .check_box {
    width: 340px;
    height: 84px;
    background: #FFFFFF;
    border: 1px solid #D0D3D9;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 21px 24px;
    display: flex;
    align-content: center;
    justify-content: space-between;
    position: relative;
    cursor: pointer;
    margin-top: 24px;
    margin-right: 20px;
  }

  .check_boxs .check_box:nth-child(3n) {
    margin-right: 0px;
  }

  .check_boxs .check_box.active {
    border: 1px solid #FF5C00;
  }

  .check_boxs .check_box.active::before,
  .extension .sel_price .option_price.active::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    background: url(../../assets/help/checked_1.png) no-repeat;
    width: 26px;
    height: 26px;
  }

  .check_boxs .check_box .check_img {
    width: 42px;
    height: 42px;
    background: #FFFFFF;
    border: 1px solid #D0D3D9;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .check_boxs .check_box.active .check_img {
    border: 1px solid #FF6F28;
  }

  .check_boxs .check_box .check_info {
    width: 235px;
    height: 42px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .check_boxs .check_box .check_info h4 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
  }

  .check_boxs .check_box.active .check_info h4 {
    color: #FF5C00;
  }

  .check_boxs .check_box .check_info p {
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
  }

  .extension {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .extension .sel_price {
    display: flex;
  }

  .extension .sel_price .option_price {
    width: 180px;
    height: 84px;
    border: 1px solid #D0D3D9;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
  }

  .extension .sel_price .option_price .price_input {
    display: flex;
    width: 137px;
    border-bottom: 1px solid #E0E0E0;
    color: #FF5C00;
  }

  .extension .sel_price .option_price .price_input input {
    border: none;
    width: 100px;
    color: #FF5C00;
  }

  .extension .sel_price .option_price .price_input input:focus-visible {
    outline: none;
  }

  .extension .sel_price .option_price.active {
    border: 1px solid #FF5C00;
  }

  .extension .sel_price .option_price.active h4 {
    color: #FF5C00;
  }

  .extension .sel_price .price_out+.price_out {
    margin-left: 20px;
  }

  .extension .sel_price .option_price h4 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
  }

  .extension .sel_price .option_price p {
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
  }

  .extension .sel_price .option_price p.active {
    color: #FF5C00;
  }

  .option_box .portrait {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .option_box .portrait .portrait_box {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .option_box .portrait .portrait_box .Gender_box {
    display: flex;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender {
    width: 100px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    position: relative;
    margin-left: -1px;
    z-index: 0;
    cursor: pointer;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender.active {
    background: #FFF2EB;
    border: 1px solid #FF5C00;
    z-index: 1;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender:nth-child(1) {
    margin-left: 0;
    border-radius: 2px 0px 0px 2px;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender:nth-last-child(1) {
    border-radius: 0px 2px 2px 0px;
  }

  .option_box .portrait .portrait_box .Gender_box .age {
    width: 100px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    position: relative;
    margin-left: -1px;
    z-index: 0;
    cursor: pointer;
  }

  .option_box .portrait .portrait_box .Gender_box .age.active {
    background: #FFF2EB;
    border: 1px solid #FF5C00;
    z-index: 1;
  }

  .option_box .portrait .portrait_box .Gender_box .age::after {
    content: '';
    width: 0px;
    height: 0px;
    border-right: 3px solid #E0E0E0;
    border-left: 3px solid transparent;
    border-top: 3px solid #E0E0E0;
    border-bottom: 3px solid transparent;
    top: 0;
    right: 0;
    position: absolute;
  }

  .option_box .portrait .portrait_box .Gender_box .age.active::after {
    border-right: 3px solid #FF5C00;
    border-left: 3px solid transparent;
    border-top: 3px solid #FF5C00;
    border-bottom: 3px solid transparent;
  }

  .option_box .like_style {
    display: flex;
    flex-wrap: wrap;
    margin-top: -10px;
  }

  .option_box .like_style>div {
    width: 100px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    margin-right: 10px;
    box-sizing: border-box;
    border-radius: 2px;
    background: #F9F9F9;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
  }

  .option_box .like_style>div.active {
    background: #FFF2EB;
    border: 1px solid #FF5C00;
    line-height: 32px;
    color: #FF5C00;
  }

  .option_box .like_style .style_checked {
    position: relative;
  }

  .option_box .like_style .style_checked::after {
    content: '';
    background: url(../../assets/help/nochecked.png);
    width: 19px;
    height: 19px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .option_box .like_style .style_checked.active::after {
    content: '';
    background: url(../../assets/help/checked_2.png);
    width: 17px;
    height: 17px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .btn_box {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    display: flex;
    justify-content: center;
  }

  .btn_box .btn {
    width: 160px;
    height: 46px;
    background: #FF6F28;
    border-radius: 2px;
    font-size: 15px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 46px;
    text-align: center;
  }

  .btn_box .btn:hover {
    background: #FF5E0E;
    cursor: pointer;
  }

  .content .list {
    margin-top: 20px;
    width: 100%;
    background: #FFFFFF;
    border-radius: 6px;
  }

  .content .list .matchingInfo {
    position: relative;
    width: 100%;
    height: 52px;
    background: #FAFAFA;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    box-sizing: border-box;
    padding: 0 26px;
    align-items: center;
  }

  .content .list .matchingInfo .title {
    font-size: 18px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333;
    margin-right: 15px;
  }

  .content .list .matchingInfo .info {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 980px;
  }

  .content .list .matchingInfo .btn {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FF6F28;
    cursor: pointer;
  }

  .content .list .rec {
    display: flex;
    box-sizing: border-box;
    padding: 0 26px;
    margin-top: 30px;
  }

  .content .list .rec h5 {
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
    margin-right: 30px;
  }

  .content .list .rec .btn {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #38A1FF;
    cursor: pointer;
  }

  .content .list .rec .btn i {
    transform: rotate(90deg);
  }

  .content .list .keywords {
    display: flex;
    align-items: center;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 0 26px;
  }

  .content .list .keywords p {
    margin-right: 20px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
  }

  .content .list .keywords .keyword {
    width: 90px;
    height: 29px;
    background: #FAFAFA;
    border-radius: 2px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    line-height: 29px;
    text-align: center;
    cursor: pointer;
  }

  .content .list .keywords .keyword+.keyword {
    margin-left: 16px;
  }

  .content .list .keywords .keyword.active {
    box-sizing: border-box;
    line-height: 27px;
    border: 1px solid #FF5C00;
    background: #FFF2EB;
    color: #FF6F28;
  }

  .content .list .datas {
    box-sizing: border-box;
    padding: 0 26px;
  }

  .content .list .datas .item {
    display: flex;
    align-items: center;
    height: 154px;
    width: 100%;
    border-bottom: 1px solid #F0F0F0;
  }

  .content .list .datas .item:nth-last-child(1) {
    border-bottom: none;
  }

  .content .list .datas .item img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-bottom: auto;
    margin-top: 40px;
    border: 1px solid #e0e0e0;
  }

  .content .list .datas .item .info {
    margin-left: 20px;
    width: 430px;
  }

  .content .list .datas .item .info h2 {
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
  }

  .content .list .datas .item .info .cate {
    display: inline-block;
    height: 26px;
    background: #F6F6F6;
    border-radius: 2px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    text-align: center;
    padding: 0 10px;
    margin: 12px 0;
  }

  .content .list .datas .item .info .tags {
    display: flex;
  }

  .content .list .datas .item .info .tags .tag {
    height: 24px;
    background: #FFF2EB;
    border-radius: 2px;
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FF6F28;
    line-height: 24px;
    padding: 0 10px;
  }

  .content .list .datas .item .info .tags .tag+.tag {
    margin-left: 8px;
  }

  .content .list .datas .item .num {
    width: 100px;
  }

  .content .list .datas .item .num div {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 800;
    color: #666666;
    text-align: center;
  }

  .content .list .datas .item .num p {
    margin-top: 6px;
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
    text-align: center;
  }

  .content .list .datas .item .line {
    width: 1px;
    height: 30px;
    background: #F5F5F6;
    margin: 0 70px;
  }

  .content .list .datas .item .price {
    color: #FF5C00;
    display: flex;
  }

  .content .list .datas .item .price span {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 800;
    margin-top: 9px;
  }

  .content .list .datas .item .price .price_text {
    font-size: 20px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 800;
    color: #FF5C00;
    margin-right: 6px;
  }

  .content .list .datas .item .price .preview:hover {
    cursor: pointer;
  }

  .content .list .datas .item .price .preview i {
    display: block;
    background: url(../../assets/help/preview.png);
    width: 14px;
    height: 14px;
  }

  .content .list .datas .item .btn {
    width: 72px;
    height: 30px;
    background: #FF6F28;
    border-radius: 2px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FFFFFF;
    margin-left: auto;
  }

  .in_preview {
    padding: 24px;
    box-sizing: border-box;
  }

  .in_preview h3 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
    height: 30px;
    border-bottom: 1px solid #F5F5F6;
  }

  .in_preview .price_item {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .in_preview .price_item .corr_price {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    color: #FF5C00;
    font-weight: 800;
    display: flex;
  }

  .in_preview .price_item .corr_price span {
    font-size: 14px;
    padding-top: 4px;
  }

  .in_preview .price_item .corr_price .price_t {
    font-size: 18px;
  }

  .noData {
    width: 100%;
    height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .noData p {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    line-height: 32px;
  }

  .datas_noData {
    width: 100%;
    height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .datas_noData p {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    line-height: 32px;
  }

  .page>>>.el-select .el-input.is-focus .el-input__inner,
  .page>>>.el-select .el-input__inner:focus{
    border-color: #E0E0E0;
  }

  .el-select-dropdown__item.selected{
    color: #FF5C00;
  }

  .page>>>.el-input__inner{
    width: 175px;
    height: 34px;
    border-radius:2px;
  }
  .page .select_area_province,
  .page .select_area_city{
    width: 100%;
    margin-top: 10px;
  }
  .page .option_box .portrait .portrait_box .select_area_province .Gender_box{
    display: block;
  }
  .page .option_box .portrait .portrait_box .select_area_province .Gender_box .Gender{
    display: inline-block;
    width: auto;
    padding: 0 23px;
    margin-bottom: 6px;
  }
  .page>>>.el-pagination .btn-next .el-icon{
    text-align: center;
  }
  .pages{
    margin-top: 0;
    margin-right: 20px;
    padding-bottom: 20px;
  }
  .rankType{
    position: absolute;
    right: 20px;
  }
</style>